<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="8">
        <v-card min-height="600">
          <div class="card">
            <HtmlLessonExecution
              v-if="activeScreen.type === 'HtmlScreenExecution'"
              :key="activeScreenIndex"
              :screen="activeScreen"
            />
            <ImageLessonExecution
              v-if="activeScreen.type === 'ImageScreenExecution'"
              :key="activeScreenIndex"
              :screen="activeScreen"
            />
            <TestLessonExecution
              v-if="activeScreen.type === 'TestScreenExecution'"
              :key="activeScreenIndex"
              :screen="activeScreen"
              :element-finished="elementFinished"
              :screen-index="activeScreenIndex"
              :screens="execution.screens"
              @questionAnswered="questionAnswered"
            />
            <VideoLessonExecution
              v-if="activeScreen.type === 'VideoScreenExecution'"
              :key="activeScreenIndex"
              :screen="activeScreen"
            />
          </div>
        </v-card>
      </v-col>
    </v-row>
    <NavigationButtons
      :active-index="activeScreenIndex"
      :screens="execution.screens"
      :back-loading.sync="backLoading"
      :next-loading="nextLoading"
      :finish-loading="finishLoading"
      @back="changePage"
      @next="changePageWithSave"
      @finish="endLesson"
    />
  </v-container>
</template>

<script>
import NavigationButtons from '@/components/course/navigation/NavigationButtons.vue';
import HtmlLessonExecution from '@/components/course/element/lesson/HtmlLessonExecution.vue';
import ImageLessonExecution from '@/components/course/element/lesson/ImageLessonExecution.vue';
import TestLessonExecution from '@/components/course/element/lesson/TestLessonExecution.vue';
import VideoLessonExecution from '@/components/course/element/lesson/VideoLessonExecution.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('courseExecution');

export default {
  components: {
    NavigationButtons,
    HtmlLessonExecution,
    ImageLessonExecution,
    TestLessonExecution,
    VideoLessonExecution
  },
  props: {
    element: {
      type: Object,
      required: true
    },
    courseId: {
      type: Number,
      required: true
    }
  },
  data: function() {
    return {
      activeScreenIndex: 0,
      persistingElement: JSON.parse(JSON.stringify(this.element)),
      backLoading: false,
      nextLoading: false,
      finishLoading: false
    };
  },
  computed: {
    execution() {
      return JSON.parse(this.persistingElement.execution);
    },
    activeScreen() {
      return this.execution.screens[this.activeScreenIndex];
    },
    elementFinished() {
      return this.persistingElement.state !== 1 && this.persistingElement.state !== 2;
    }
  },
  methods: {
    ...mapActions(['elementExecutionOpened', 'finishElementExecution']),
    changePage(ev) {
      this.backLoading = true;
      this.activeScreenIndex = ev.newIndex;
      this.backLoading = false;
    },
    async changePageWithSave(ev) {
      this.nextLoading = true;
      await this.elementExecutionOpened({
        element: this.persistingElement,
        courseId: this.courseId
      });
      this.changePage(ev);
      this.nextLoading = false;
    },
    async endLesson() {
      this.finishLoading = true;
      await this.finishElementExecution({
        element: this.persistingElement,
        courseId: this.courseId
      });
      await this.$router.push(`/course/${this.courseId}`);
      this.finishLoading = false;
    },
    questionAnswered(ev) {
      const newExecution = JSON.parse(this.persistingElement.execution);

      if (ev.type === 'SingleChoiceQuestionExecution') {
        newExecution.screens[this.activeScreenIndex] = {
          ...newExecution.screens[this.activeScreenIndex],
          questions: newExecution.screens[this.activeScreenIndex].questions.map(question => {
            if (ev.questionId === question.id) {
              question.selectedAnswerId = ev.answerId;
            }

            return question;
          })
        };
      } else {
        newExecution.screens[this.activeScreenIndex] = {
          ...newExecution.screens[this.activeScreenIndex],
          questions: newExecution.screens[this.activeScreenIndex].questions.map(question => {
            if (ev.questionId === question.id) {
              question.selectedAnswerIds = ev.answerIds;
            }

            return question;
          })
        };
      }

      this.persistingElement.execution = JSON.stringify(newExecution);
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  padding: 16px;
}
</style>
